// AUTH ACTIONS
export const ERROR_AUTH = 'ERROR_AUTH';
export const MESSAGE_AUTH = 'MESSAGE_AUTH';
export const USER_AUTH = 'USER_AUTH';
export const SET_TOAST = 'SET_TOAST';

// AUTH ACTIONS
export const ERROR_USER = 'ERROR_USER';
export const MESSAGE_USER = 'MESSAGE_USER';
export const GET_TOOLS = 'GET_TOOLS';
export const GET_CONGRESS = 'GET_CONGRESS';
export const GET_NEWS = 'GET_NEWS';
export const GET_NEWS_ALL = 'GET_NEWS_ALL';
export const GET_NEW = 'GET_NEW';
export const POST_NEW = 'POST_NEW';
export const PUT_NEW = 'PUT_NEW';
export const GET_GIF = 'GET_GIF';
export const GET_METEO = 'GET_METEO';
export const SET_ACTIVE_ACTU = 'SET_ACTIVE_ACTU';

// CONTENT (consultation)
export const ERROR_CONTENT = 'ERROR_CONTENT';
export const GET_TOOL = 'GET_TOOL';
export const GET_THERAPEUTIC_AREAS = 'GET_THERAPEUTIC_AREAS';
export const GET_THERAPEUTIC_AREA = 'GET_THERAPEUTIC_AREA';
export const GET_DRUGS = 'GET_DRUGS';
export const GET_DRUG = 'GET_DRUG';
export const GET_DRUG_VARIATIONS = 'GET_DRUG_VARIATIONS';
export const GET_PATHOLOGIES = 'GET_PATHOLOGIES';
export const GET_PATHOLOGY = 'GET_PATHOLOGY';
export const GET_CENTERS = 'GET_CENTERS';
export const GET_CENTER = 'GET_CENTER';
export const GET_CONTACTS = 'GET_CONTACTS';
export const GET_CONTACT = 'GET_CONTACT';
export const GET_CONGRESS_ITEM = 'GET_CONGRESS_ITEM';
export const GET_COMPANIES = 'GET_COMPANIES';
export const GET_COMPANY = 'GET_COMPANY';

// NOTIF ACTIONS
export const ERROR_NOTIFS = 'ERROR_NOTIFS';
export const MESSAGE_NOTIFS = 'MESSAGE_NOTIFS';
export const GET_NOTIFS = 'GET_NOTIFS';
export const PUT_NOTIF = 'PUT_NOTIF';

// PROJECT ACTIONS
export const ERROR_PROJECTS = 'ERROR_PROJECTS';
export const MESSAGE_PROJECTS = 'MESSAGE_PROJECTS';
export const GET_PROJECTS = 'GET_PROJECTS';
export const GET_PROJECT = 'GET_PROJECT';
export const PUT_PROJECT = 'PUT_PROJECT';
export const PROJECT_IS_LOADING = 'PROJECT_IS_LOADING';
export const EDIT_TASK = 'EDIT_TASK';

// PLANNING ACTIONS
export const ERROR_PLANNINGS = 'ERROR_PLANNINGS';
export const MESSAGE_PLANNINGS = 'MESSAGE_PLANNINGS';
export const GET_PLANNING = 'GET_PLANNING';
export const PUT_PLANNING = 'PUT_PLANNING';
export const SET_ACTIVE_CR = 'SET_ACTIVE_CR';
export const SET_ACTIVE_CR_LIST = 'SET_ACTIVE_CR_LIST';
export const GET_PLANNING_LIST = 'GET_PLANNING_LIST';
export const GET_CR_LIST = 'GET_CR_LIST';

// PROJECT ACTIONS
export const ERROR_TODOS = 'ERROR_TODOS';
export const MESSAGE_TODOS = 'MESSAGE_TODOS';
export const GET_TODOS = 'GET_TODOS';
export const POST_TODO = 'POST_TODO';
export const PUT_TODO = 'PUT_TODO';
export const DELETE_TODO = 'DELETE_TODO';

// FILE ACTIONS
export const ERROR_FILE = 'ERROR_FILE';
export const DELETE_FILE = 'DELETE_FILE';
export const POST_FILE = 'POST_FILE';
